<template>
  <v-form class='createUserForm' v-model='valid' ref='createUserForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='user.username'
            :error-messages='error.username'
            label='User Name'
            placeholder='User Name'
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <searchable-select :value.sync="user.user_role_id" :options="{ url: 'user_role', label: 'User Role'}" :errorMessage="error.user_role_id" :selectedData="{id: user.user_role_id, text: user.user_role_name}"/>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='user.email'
            :error-messages='error.email'
            label='Email'
            placeholder='Email'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='user.password'
            :error-messages='error.password'
            type="password"
            label='Password'
            placeholder='Password'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='user.confirm_password'
            :error-messages='error.confirm_password'
            type="password"
            label='Confirm Password'
            placeholder='Confirm Password'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="user.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.getDataById(id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        this.getDataById(_storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      user: { status: 0 },
      error: {},
    }
  },
  methods: {
    getDataById (id) {
      this.$axios.post('getUserById/' + id).then((res) => {
        this.user = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        console.log(this.user)
        const route = this.edit_id ? 'saveUser/' + this.edit_id : 'saveUser'
        this.$axios.post(route, this.user).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/user')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createUserForm.validate()
      }
    },
    reset () {
      this.$refs.createUserForm.reset()
      setTimeout(() => {
        this.user = { status: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>

<style>
.createUserForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createUserForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
